import ResearchGroupPage from './ResearchGroupPage';
import './Main.css';
import { HashRouter as Router, Switch, Route, NavLink, useLocation, Redirect } from 'react-router-dom';
import CareerPage from './CareerPage';
import ResultsPage from './ResultsPage';
import InternalPage from './InternalPage';
import InfrastructurePage from './InfrastructurePage';

export default function Main() {

    return <Router>
        <Header/>
        <div className="page-root">
            <Switch>
                {/*<Route exact path="/news">
                    Hírek
                </Route>*/}
                <Route exact path="/infrastructure/:selectedMenu?">
                    <InfrastructurePage />
                </Route>
                <Route path="/results/:selectedMenu?">
                    <ResultsPage />
                </Route>
                <Route path="/groups/:groupId?">
                    <ResearchGroupPage />
                </Route>
                <Route path="/career/:selectedMenu?/:activeItem?">
                    <CareerPage />
                </Route>
                <Route path="/internal/:selectedMenu?">
                    <InternalPage />
                </Route>
                <Redirect to="/groups"/>
            </Switch>
        </div>
      </Router>;
}

function Header() {

    const lang = (new URLSearchParams(useLocation().search)).get("lang") === "en" ? "en" : "hu";
    return <div id="header">
        <img src="./vik.svg" alt="💡"/>
        <div className="header-right">
            <div className="header-text">
                <div className="title">
                    <h1>{lang === "hu" ? "Kutatás" : "Research"}</h1>
                </div>
                <div className="faculty">
                    <h1>{lang === "hu" ? "Budapesti Műszaki és Gazdaságtudományi Egyetem" : "Budapest University of Technology and Economics"}</h1>
                    <h2>{lang === "hu" ? "Villamosmérnöki és Informatikai Kar" : "Faculty of Electrical Engineering and Informatics"}</h2>      
                </div>
            </div>
            <div className="menu-panel">
                <Menubar lang={lang}/>
            </div>
        </div>
    </div>;
}

function Menubar(props) {

    const pageMenu = [
        //{ path: "/news", hu: "Hírek", en: "News"},
        { path: "/groups", hu: "Kutatócsoportok", en: "Research groups"},
        { path: "/results", hu: "Eredményesség", en: "Results"},
        { path: "/internal", hu: "Kutatóinknak", en: "Internal"},
        { path: "/infrastructure", hu: "Infrastruktúra", en: "Infrastructure"},
        { path: "/career", hu: "Életpálya", en: "Career"},
    ];
    const location = useLocation();
    const param = new URLSearchParams(location.search);
    const lang = props.lang;
    param.delete("lang");
    const huLink = `${location.pathname}?${param.toString()}`;
    param.set("lang", "en");
    const enLink = `${location.pathname}?${param.toString()}`;

    return <>
        <div className="menu-container">
            {pageMenu.map((d, ix) => (
                <NavLink to={() => {
                    const param = new URLSearchParams(location.search);
                    param.delete("search");
                    return `${d.path}?${param.toString()}`
                }} activeClassName="menu-active" className="menu-item" key={ix}>
                    {d[lang]}
                </NavLink>))
            }
        </div>
        <div className="menu-container">
            <NavLink to={huLink} activeClassName="menu-active" className="menu-item" isActive={() => lang === "hu"}>HU</NavLink>
            <NavLink to={enLink} activeClassName="menu-active" className="menu-item" isActive={() => lang === "en"}>EN</NavLink>
        </div>
    </>;
}
